import { render, staticRenderFns } from "./IconLabelSlot.vue?vue&type=template&id=3281f966&"
import script from "./IconLabelSlot.vue?vue&type=script&lang=js&"
export * from "./IconLabelSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports